/**
 * Which builder "New app" opens: the everyday one (/new/idea) or the agent builder (/studio), as the
 * person last chose with the ⚡ switch. A convenience kept in this browser only; it never decides
 * who may use the agent builder (the server does).
 */
export type BuilderMode = 'classic' | 'agent';

const KEY = 'saddle.builder.mode';

export function builderMode(): BuilderMode {
  try {
    return window.localStorage.getItem(KEY) === 'agent' ? 'agent' : 'classic';
  } catch {
    return 'classic';
  }
}

export function setBuilderMode(mode: BuilderMode): void {
  try {
    window.localStorage.setItem(KEY, mode);
  } catch {
    /* private mode: the switch still works, it just isn't remembered */
  }
}

/** Where "New app" goes for this person. */
export function newAppPath(): string {
  return builderMode() === 'agent' ? '/studio' : '/new/idea';
}
